<div class="webhook-log-dialog">
  <div *ngIf="loading" class="state state--loading">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Carregando log do webhook…</span>
  </div>

  <div *ngIf="errorMessage" class="state state--error">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ errorMessage }}</span>
  </div>

  <ng-container *ngIf="!loading && !errorMessage && payload">
    <div class="summary" *ngIf="payload.status || payload.nfeId">
      <span class="badge" *ngIf="payload.status">{{ payload.status }}</span>
      <span class="meta" *ngIf="payload.nfeId"><strong>NFe ID:</strong> {{ payload.nfeId }}</span>
      <span class="meta" *ngIf="payload.branch"><strong>Ramo:</strong> {{ payload.branch }}</span>
    </div>

    <p-fieldset legend="Linha do tempo" [toggleable]="true" *ngIf="payload.log?.length" styleClass="webhook-fieldset">
      <p-table [value]="payload.log" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="220px">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 11rem">Data/hora</th>
            <th>Descrição</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ formatLogDatetime(row.datetime) }}</td>
            <td class="desc-cell">{{ row.description }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-fieldset>

    <p-fieldset legend="Resumo (docResponse)" [toggleable]="true" [collapsed]="true" *ngIf="payload.docResponse" styleClass="webhook-fieldset">
      <pre class="json-block">{{ payload.docResponse | json }}</pre>
    </p-fieldset>

    <p-fieldset legend="JSON completo" [toggleable]="true" [collapsed]="false" styleClass="webhook-fieldset">
      <pre class="json-block json-block--full">{{ formattedJson }}</pre>
    </p-fieldset>
  </ng-container>

  <div class="actions">
    <button type="button" class="easymarine primary" (click)="close()">Fechar</button>
  </div>
</div>
